import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import WOTemplateForm from '../components/WOTemplateForm';
import useWOTemplateCreate from '../hooks/useWOTemplateCreate';
import useWOTemplateQuery from '../hooks/useWOTemplateQuery';
import type { WorkOrderTemplate } from '#/graphql/types';
import { createFields } from '../components/WOTemplateForm/fields';

const NewWOTemplatesPage: React.FC = () => {
  const title = 'New WO Template';
  const [searchParams] = useSearchParams();
  const copyFromId = searchParams.get('copyFrom') || undefined;

  const { data: copyFromData, loading: copyFromLoading } = useWOTemplateQuery(copyFromId);
  const sourceTemplate = copyFromData?.getWorkOrderTemplate?.data;

  const newWOTemplate = useMemo(() => {
    const number = crypto.getRandomValues(new Uint32Array(1))[0] % 10000;

    if (copyFromId && sourceTemplate) {
      const {
        id,
        displayNumber,
        createdAt,
        createdBy,
        createdByUser,
        updatedAt,
        updatedBy,
        updatedByUser,
        userId, // Not used but remove it just in case
        locationId, // Not used but remove it just in case
        assignmentGroupId, // Not used but remove it just in case
        manufacturer,
        assetManufacturerId,
        assetType,
        assetTypeId,
        model,
        assetModelId,
        tenant,
        ...rest
      } = sourceTemplate;

      return {
        ...rest,
        title: `${rest.title} - Copy`,
        number,
      };
    }
    return {
      number,
    } as WorkOrderTemplate;
  }, [copyFromId, sourceTemplate]);

  const { createWOTemplate } = useWOTemplateCreate();

  return (
    <SubPage title={title} showGoBackButton type="form" isLoading={copyFromLoading}>
      <WOTemplateForm
        title={title}
        woTemplate={newWOTemplate}
        fields={createFields}
        submit={createWOTemplate}
      />
    </SubPage>
  );
};

export default React.memo(NewWOTemplatesPage);
